var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardExitCrossBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#4DAC89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29288 17.7434C4.90221 18.1338 4.90221 18.7667 5.29288 19.1571C5.68354 19.5475 6.31693 19.5475 6.70759 19.1571L12.2298 13.6389L17.7524 19.1575C18.1431 19.5479 18.7764 19.5479 19.1671 19.1575C19.5578 18.7671 19.5578 18.1342 19.1671 17.7438L13.6445 12.2251L19.1671 6.7065C19.5578 6.31611 19.5578 5.68317 19.1671 5.29279C18.7764 4.9024 18.1431 4.9024 17.7524 5.29279L12.2298 10.8114L6.70759 5.29316C6.31693 4.90277 5.68354 4.90277 5.29288 5.29316C4.90221 5.68354 4.90221 6.31648 5.29288 6.70687L10.8151 12.2251L5.29288 17.7434Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardExitCrossBlack);
export default __webpack_public_path__ + "static/media/card-exit-cross-black.a8aa2d25dd8b62c1d154e8a96c8bb314.svg";
export { ForwardRef as ReactComponent };